import { Base } from '@studiometa/js-toolkit';
import Hero from './Hero.js';
import Fade from './Fade.js';
import ParallaxMedia from './ParallaxMedia.js';

/**
 * App
 */
export default class Animations extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'Animations',
    components: {
      Hero,
      '[data-fade]': Fade,
      ParallaxMedia,
    },
  };
}
